import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkboxes", "backdrop", "checkbox"]

  connect() {
    this.expanded = false
  }

  showCheckboxes(e) {
    e.stopPropagation()
    if (!this.expanded) {
      this._open()
    } else {
      this._close()
    }
  }

  out(e) {
    this._close()
    e.stopPropagation()
  }

  in(e) {
    e.stopPropagation()
  }

  selectAll(e) {
    e.preventDefault()
    e.stopPropagation()
    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = true
    })
  }

  clearAll(e) {
    e.preventDefault()
    e.stopPropagation()
    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = false
    })
  }

  _open() {
    this.checkboxesTarget.style.display = "block"
    if (this.hasBackdropTarget) {
      this.backdropTarget.style.display = "block"
    }
    this.expanded = true
  }

  _close() {
    this.checkboxesTarget.style.display = "none"
    if (this.hasBackdropTarget) {
      this.backdropTarget.style.display = "none"
    }
    this.expanded = false
  }
}